module.exports = __webpack_public_path__ + "img/options-antireflection.692586f7.svg";